// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Datasenter",
        "pull_refresh": "Trekk ned for å oppdatere",
        "release_refresh": "Slipp for å oppdatere",
        "refresh_loading": "Laster ...",
        "footer_text": "Tjenester levert av Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Søkeland/region",
        "my_flow": "Mine data",
        "charge_code": "Kupongkode",
        "coupons": "Kuponger",
        "local_package": "Lokale data",
        "more": "Flere",
        "popular_destination": "Land/region",
        "buy_now": "Kjøp nå",
        "package_useing": "Aktiv",
        "unused": "Inaktiv",
        "download_app": "Last ned APP",
        "enter_the_mall_list": "Gå til kjøpesenteret",
        "no_data": "Ingen data ennå",
        "no_data_available": "Ingen data tilgjengelig",
        "copy_success": "Kopiering vellykket",
        "copy_fail": "Kopiering mislyktes",
        "meritsTitle": "Hva er fordelene?",
        "merits1": "Ingen SIM krevet & Ingen månedlige gebyrer",
        "merits2": "Integrert med de 2-3 ledende operatørene for automatisk nettverksbytte",
        "go_buy": "Kjøpe",
        "instant_savings": "Spar",
        "expires_in": "Utløper om",
        "download_app_tips": "Last ned appen for flere tilbud og opplevelser"
    },
    "packages": {
        "sub_title": {
            "us": "Unntatt Guam, Saipan",
            "it": "Inkludert Vatikanets by, San Marino",
            "va": "Inkludert Italia, San Marino",
            "sm": "Inkludert Italia, Vatikanets by",
            "ma": "Inkludert Vest-Sahara",
            "eh": "Inkludert Marokko",
            "ch": "Inkludert Liechtenstein",
            "li": "Inkludert Sveits",
            "fr": "Inkludert Monaco",
            "mc": "Inkludert Frankrike",
            "fi": "Inkludert Aland Islands",
            "ax": "Inkludert Finland",
            "gu": "Inkludert Nord-Mariana-øyene",
            "mp": "Inkludert Guam"
        },
        "unlimited_packages": "Ubegrenset datapakke",
        "normal_packages": "Normal datapakke",
        "multi_region_packages": "Multi-region",
        "regional_data": "Regionale data",
        "high_speed_text": "Høyhastighetsdata",
        "infiniteFlow": "Ubegrenset data",
        "unLimitData": "Ubegrænset",
        "high_speed_text_year": "Høy hastighet/MP",
        "package_list": "Pakkeliste",
        "special_offer": "Tilbud",
        "first_month": "1. Måned",
        "periodUnit": {
            "day": "dag",
            "month": "måned",
            "hour": "time",
            "year": "år"
        },
        "periodUnits": {
            "day": "dag",
            "month": "måneder",
            "hour": "time",
            "year": "år"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "mo",
            "hour": "h",
            "year": "yr"
        },
        "periodUnitMonthly":"Månedlig",
        "periodUnitsSimp": {
            "day": "d",
            "month": "mo",
            "hour": "h",
            "year": "yr"
        },
        "unlimited_good_name": {
            "day": "Dagspass",
            "month": "Månedlig pass",
            "year": "Årlig pass"
        },
        "continuousMonth": "Kontinuerlige måneder",
        "continuousDay": "Kontinuerlige dager",
        "continuousYear": "Kontinuerlige år",
        "day_invalid": "Utløpe den nåværende dagen",
        "month_invalid": "Utløpe i inneværende måned",
        "immediate_valid": "Effektiv umiddelbart",
        "tomorrow_day_valid": "Effektivt fra neste dag",
        "tomorrow_month_valid": "Effektivt fra neste måned",
        "detail": {
            "cell_flow": "Data",
            "cell_period": "Gyldighet",
            "buy_quantity": "Beløp",
            "use_area": "Dekning",
            "use_intro": "Vilkår og betingelser",
            "buy_btn": "Bestille",
            "pay": "Betale",
            "buy_tips": "Du har %@packageName-pakketet i bruk. Vil du kjøpe dette pakketet?",
            "haveOrderTips": "Ordre med ventende betaling opprettet. Klikk Bekrefte for å gå til min dataside！"
        },
        "confirm": {
            "title": "Bestillingsbekreftelse",
            "real_pay_amount": "Beløp betalt",
            "online_payment": "Online betaling",
            "create_order_error": "Oppsettet mislyktes"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Få bestillingsstatus ...",
            "buy_success": "Bestill fullført",
            "buy_pending": "I påvente av bekreftelse",
            "buy_pending_tip": "Betalning i prosess ... Hvis betaling ikke ble overført innen 10 minutter, kan du kontakte oss for støtte.",
            "get_payment_info_fail": "Betalingsinfo -anskaffelse mislyktes",
            "cell_package": "Pakke",
            "cell_buy_amount": "Subtotal",
            "cell_real_amount": "Beløp betalt",
            "go_to_order_btn": "Gå til pakken min",
            "back_home": "Tilbake til hjemmet",
            "back_mall": "Tilbake til kjøpesenteret",
            "ordersn_empty": "Bestill SN kan ikke være tom",
            "order_search_error": "Uventet feil",
            "goodsName": 'Produktnavn'
        },
        "fail": {
            "payment_fail": "Betalingen mislyktes",
            "back_home": "Tilbake til hjemmet"
        }
    },
    "CountryGroup": {
        "title": "Land/region",
        "placeholder": "Søkeland eller region",
        "clear": "Klar",
        "history": "Søkehistorikk"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kupongkode",
            "minititle": "Kupongkode",
            "input": "Vennligst skriv inn toppkoden",
            "explain": "Tips: Trykk på skanneknappen øverst til høyre for å skanne QR-koden på kupongkortet, eller skriv inn kupongkoden manuelt (skiller mellom store og små bokstaver) hvis det ikke fungerer.",
            "submit": "Send inn",
            "exchange": "Innløse",
            "cancel": "Kansellere",
            "Inquiry": "Er du sikker på å bytte",
            "ErrorCode": "Lad opp kodefeil"
        },
        "recharge_success": {
            "package": "Pakke",
            "content": "Vellykket innløst",
            "back": "Tilbake til kjøpesenteret",
            "view_packets": "Gå til pakken min"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktivert",
            "isFirst": "Prioritert",
            "toFirst": "Sett prioritet",
            "inactive": "Inaktivert"
        },
        "periodUnits": {
            "minute": "minutt",
            "hour": "time",
            "day": "dag",
            "month": "måned"
        },
        "useIntro": {
            "tip1": "Ubegrenset datapakke har høyere prioritet enn volumdatapakke.",
            "tip2": "Bruksprioriteten vil være basert på kjøpsdato for samme type pakke, dvs. pakken med den tidligste kjøpsdatoen vil bli brukt opp først, mens prioriteten til enkeltregionspakker er høyere enn regional pakke.",
            "tip3": "Du kan også manuelt justere prioriteringen av å bruke pakker av samme type."
        },
        "myFlow": "Mine data",
        "remainingFlow": "Data igjen",
        "remainingTime": "Gyldig venstre",
        "remainingHighFlow": "Høyhastighetsdata igjen",
        "validPeriod": "Gyldighet",
        "noneFlow": "Ingen datapakke",
        "noneFlowTip": "Vennligst kjøp datapakken og nyt nettverket av høy kvalitet",
        "buyPackFlow": "Kjøpe pakker",
        "checkInvalidFlow": "Sjekk utløpt datapakke",
        "orderList":  {
            "title": "mine bestillinger",
            "amount_paid": "Total",
            "device": "Eid enhet",
            "order_details": "Bestillingsdetaljer",
            "total_amont": "Delsum",
            "orderSN": "Bestillingsnr.",
            "createTime": "Opprettingstid",
            "cancelTime": "Stengt tid",
            "payTime": "Bestillingstid",
            "unsubTime": "Kansellert tid",
            "payMethod": "Betalingsmåte",
            "thirdSN": "Transaksjonsnr.",
            "delete": "Slett",
            "cancel": "Kanseller bestillingen",
            "unsub": "Tilbakebetaling",
            "goto_cancel": "Vil du kansellere bestillingen?",
            "goto_unsubscribe": "Vil du avslutte abonnementet på bestillingen?",
            "delete_Tips": "Bestillingen kan ikke gjenopptas etter å ha blitt slettet, derfor kan ikke dine etterserviceproblemer håndteres.Er du sikker på at du vil slette den?",
            "status_success": "Fullført",
            "status_pending": "Ubetalt",
            "status_cancel": "Lukket",
            "status_unsub": "Kansellert",
            "payMethod_stripe": "Kredittkort"
          },
    },
    "registerlogin": {
        "create_account_tip":"Opprett en konto, start eksklusiv opplevelse",
        "select_country_tip":"Enhetsbruk land/region",
        "email_name": "Post",
        "phone_name": "Telefon",
        "email_address": "E-postadresse",
        "password": "Passord",
        "country": "Land",
        "select_country": "Velg et land",
        "cancel": "Kansellere",
        "confirm": "Sikker",
        "please_enter": "Vennligst skriv inn 6-20 tegn (kombinasjon av bokstaver, tall eller symboler)",
        "select_country_tips": "Landsvalg er for å se lokale pakker. Det kan ikke endres etter registrering. Bekreft!",
        "global_roaming": "Internasjonal domenekode",
        "phone_number": "Telefonnummer",
        "agree": "Enig",
        "user_agreement": "Brukeravtale",
        "and": "og",
        "privacy_policy": "Personvernregler",
        "register_login": "Registrer deg eller logg inn",
        "login_error": "Antall pålogginger er for hyppig, prøv igjen senere!",
        "register_error": "Antall registreringer er for hyppig, prøv igjen senere!",
        "forgot_pwd": "Glem passordet",
        "app_tips": "Logg deg på appen med denne kontoen etter å ha lastet den ned for å få tilgang til flere funksjoner.",
        "download_app": "Gå for å laste ned appen",
        "rememberPwd": "Husk passord",
        "third_login": "Fortsett med",
        "agreement_tips": "Vennligst merk brukeravtalen og personvernreglene",
        "selectCountry_tips": "Vær oppmerksom på at det registrerte landet direkte vil påvirke følgende betalingsmetoder og valutaer, velg i henhold til ditt behov.",
        "login_error_cancel": "Brukeren avbrutt påloggingen",
        "login_error_auth": "Tillat pop-ups fra nettleserinnstillingene",
        "device_tips": "Enhet venter på aktivering. Behandles innen 24 timer."
    },
    "forgotPwd": {
        "forgot_pwd": "Glem passordet",
        "email_address": "E-postadresse",
        "next": "NESTE",
        "email_has_been_sent": "Vi har sendt en e-post til %@email. Vennligst klikk på lenken og følg trinnene for å hente passordet ditt.",
        "have_retrieved_it": "Jeg har funnet det",
        "unable_to_receive_email": "Kan du ikke motta e-posten? Vennligst sjekk om det er e-post fra %@email under spam og slettet postkatalog",
        "or": "eller",
        "resend": "Send ut",
        "global_roaming": "Internasjonal domenekode",
        "phone_number": "Telefonnummer",
        "verification_code_has_been_sent": "Vi har sendt bekreftelseskoden til:",
        "verification_code": "Verifiseringskode",
        "no_verification_code_received": "Mottok ikke bekreftelseskoden?",
        "please_enter": "Vennligst skriv inn 6-20 tegn (kombinasjon av bokstaver, tall eller symboler)",
        "reset_password": "Tilbakestill passord",
        "reset_successful": "Tilbakestill vellykket"
    },
    "coupons": {
        "coupons_name": "Kuponger",
        "no_coupons": "Ingen kuponger ennå",
        "no_data": "Ingen data ennå",
        "applicable_to_the_following": "Kuponger er egnet for følgende datapakke"
    },
    "digital":{
        "title":"Enhet SN",
        "purchased":"Mine kjøp",
        "viewAll":"Flere",
        "skinStore":"Produktbutikk",
        "completed":"Kjøpt",
        "goBuy":"Kjøpe",
        "order": {
          "title":"Kjøpte bestillinger"
        },
        "detail": {
          "describe":"Beskrivelse"
        }
    },
    "viewPL": {
        "other": 'andre'
    },
    "invalidFlow": {
        "stateName": "Status",
        "state": {
            "NOT_ACTIVATED": "Inaktivert",
            "IN_USING": "Tilgjengelig",
            "USE_END": "Utmattet",
            "EXPIRE": "Utløpt",
            "TRANSFER": "Overføre",
            "UNSUBSCRIBE": "Avslutt abonnement",
            "VALID": "Gyldig",
            "INVALID": "Ugyldig",
            "EXCHANGE_POINTS": "Innløse poeng"
        },
        "noneFlow": "Ingen utgåtte datapakke",
        "pageName": "Utløpt datapakke"
    },
    "flowDetail": {
        "title": "Datadetaljer",
        "flow": "Data",
        "validTime": "Gyldige starter",
        "invalidTime": "Gyldig til",
        "coverage": "Dekning",
        "useIntro": "Vilkår og betingelser",
        "purchaseTime": "Kjøpt på",
        "subtotal": "Subtotal",
        "status": "Status",
        "cancel": "Kansellere",
        "buyAgain": "Kjøp den igjen",
        "validity": "Gyldighet",
        "tip": "Legg merke til",
        "cancelTip": "Er du sikker på at du vil tilbakebetale denne pakken?",
        "dataLeft": "Data igjen",
    },
    "netError": {
        "try_again": "Prøv igjen",
        "net_error": "Ingen nettverk",
        "try_again_desc": "Vennligst sjekk nettverksinnstillingen og prøv igjen"
    },
    "loadFail": {
        "try_again": "Prøv igjen",
        "load_fail": "Lasting mislyktes",
        "load_fail_desc": "Databelastning mislyktes, prøv igjen",
        "IMEI_Not_Exist": "IMEI ikke eksisterer, prøv å komme inn fra høyre inngang",
        "Project_Not_Exist": "En feil oppstår. Ta kontakt med kundeservice. (01)",
        "commonError": "En feil oppstår. Ta kontakt med kundeservice."
    },
    "settlement_Easy_and_convenient": "Lett og praktisk",
    "settlement_Great_deal": "Mye",
    "settlement_Safe_and_secure": "Trygt og sikkert",
    "settlement_Autopay_service_regulation": "Regulering av automatisk betaling",
    "settlement_Read": "Lese",
    "settlement_No_coupon": "Ingen tilgjengelig kupong",
    "settlement_Subtotal": "Subtotal",
    "settlement_Coupon": "Kupong",
    "settlement_TOTAL": "Total",
    "settlement_promotion_tip": "Kampanjetilbudet kan ikke brukes i forbindelse med noen kuponger",
    "settlement_coupon_tip": "Kupongen kan ikke brukes i forbindelse med andre kampanjetilbud",
    "member_myFlow_noList": "Ingen data ennå",
    "detail_se_content": "En sikker, enkel og praktisk måte. Du kan melde deg av til enhver tid",
    "Enter_Promo_code": "Kampanjekode",
    "Enter_Promo_Coupon": "Kupong",
    "settlement_Not_used_coupon": "Kupong ikke brukt",
    "settlement_Available_coupon": "Tilgjengelig",
    "settlement_Unavailable_coupon": "Utilgjengelig",
    "please_Enter_Promo_code": "Vennligst skriv inn kampanjekoden",
    "please_Select_Coupon_use": "Velg kupongen du vil bruke.",
    "Buy_Now": "Kjøp nå",
    "Dont_Use_Any": "Ikke bruk noen",
    "settlement_confirm": "Bekrefte",
    "settlement_tips": "Bekrefte",
    "flowDetail_unsubscribe": "Avslutt abonnement",
    "flowDetail_unsubscribed": "Avsluttet",
    "flowDetail_isCancelPackage": "Avslutte abonnementet denne pakken?",
    "flowDetail_confirmAgreementUnsubscribe": "Du kan ikke ha mye etter avmelding. Er du sikker på at du vil melde deg ut?",
    "flowDetail_cancel": "Kansellere",
    "flowDetail_cancelSuccess": "Avslutt abonnement",
    "packages_detail_promotion": "Forfremmelse",
    "orderTips":{
        "iDay" : "dag",
        "iDays" : "dager",
        "iMonth" : "måned",
        "iMonths" : "Måneder",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol På ditt første kjøp, Betal %@money/%@periodSymbol senere, Du kan melde deg av til enhver tid",
        'Monthly_discount':"Lagre %@saveMoney hver %@period! Du kan melde deg av til enhver tid",
        'Ordinary_monthly_package':"En sikker, enkel og praktisk måte. Du kan melde deg av til enhver tid",
        "AlreadyPurchased":'Beklager at du bare kan abonnere på en datapakke for øyeblikket. Avslutt abonnement fra “%@” og abonner senere på hvilken som helst pakke du ønsker etter at den utløper.',
        "Contract_recommendation_First":'<label>Betal bare med Autopay -tjenesten</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Du kan melde deg av til enhver tid'
        +'<a class="btn">Abonner ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Bare med autopay -tjeneste, betal</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Du kan melde deg av til enhver tid'
        +'<a class="btn">Abonner ></a></p>',
        "Contract_recommendation_General":"<label>Med autopay -tjeneste</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">En sikker, enkel og praktisk måte. Du kan melde deg av til enhver tid'
        +'<a href="javascript:;" class="btn">Abonner ></a></p>',
        'BanlanceDoubleCheck':'Er du sikker på at du vil betale med saldo?',
    },
    feedback: {
        title: "tilbakemelding",
        placeholder: "Vennligst skriv inn landet du ønsker å besøke eller andre spørsmål, så vil vi imøtekomme dine behov så snart som mulig!",
        submit: "Sende inn",
        submit_success: "Innsending vellykket",
        other_opinions: "Andre meninger"
    },
    view_country_input: 'Vennligst skriv inn kontoen din',
    "select_package": {
        "title": "Velg Data",
        "allPackage": 'Alle Data',
        "type": "Type",
        "flow": "Data",
        "month_package": "Månedsplan",
        "flow_package": "Datapakke",
        "time": "Varighet",
        "period": "Syklus",
        "auto_debit": "Auto-Uttak Info",
        "auto_subscribe": "Auto-Forlengelse",
        "detail": "Data Detaljer",
        "carrier": "Støttede Operatører",
        "country": "Dekkte Lande",
        "notice": "Kjøpsguide"
    }
}